<div class="row text-center">
	<div class="col-md-12">
		<button
			class="btn btn-primary custom-btn-sync"
			type="button"
			(click)="onRoute()"
		>
			<span>{{ 'Redirect for rquiremnts' | translate }}</span>
		</button>
	</div>
</div>
